import React from 'react';
import style from './ExerciseRecordCard.module.css';
import watchIcon from '../../../images/common/i_watch.svg';
import editIcon from '../../../images/common/i_modify_on.svg';
import deleteIcon from '../../../images/common/i_delete.svg';

const ExerciseRecordCard = ({ item, sourceLabel, onEdit, onDelete }) => {
    return (
        <div className={style.card}>
            <div className={style.top}>
                <strong className={style.name}>{item.name}</strong>

                {item.source !== 'watch' && (
                    <div className={style.actions}>
                        <button className={style.editBtn} onClick={onEdit}>
                            <img src={editIcon} className={style.actionIcon} alt="" />
                            <span className="blind">수정</span>
                        </button>
                        <button className={style.deleteBtn} onClick={onDelete}>
                            <img src={deleteIcon} className={style.actionIcon} alt="" />
                            <span className="blind">삭제</span>
                        </button>
                    </div>
                )}
                
            </div>
            <div className={style.values}>
                <span className={style.kcal}>{item.kcal}</span>
                <span className={style.unit}>kcal</span>
                <span className={style.minutes}>{item.minutes}</span>
                <span className={style.unit}>분</span>
            </div>
            <div className={style.bottom}>
                <span className={style.time}>{item.time}</span>
                {sourceLabel && (
                    <span className={style.source}>
                        {item.source === 'watch' && <img src={watchIcon} className={style.watchIcon} />}
                        {sourceLabel}
                    </span>
                )}
            </div>
        </div>
    );
};

export default ExerciseRecordCard;